import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBRXwe0B849TYDOLCaeDNacoPHrd0dTmX8",
  authDomain: "pdtaskmanager.firebaseapp.com",
  projectId: "pdtaskmanager",
  storageBucket: "pdtaskmanager.firebasestorage.app",
  messagingSenderId: "962289220625",
  appId: "1:962289220625:web:5ab2ca9c8a83a229ecc5b0"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
// Persistenza offline: DISATTIVATA. Con Firestore 10.14 la cache persistente provocava
// "INTERNAL ASSERTION FAILED: Unexpected state" (crash dell'intera app) quando un ascoltatore
// veniva rifiutato dalle regole o riavviato in fretta. Si riattiva solo dopo un collaudo vero,
// con una versione dell'SDK che non ha questo difetto.
export const db = getFirestore(app);
export const storage = getStorage(app);

let messaging = null;
try {
  messaging = getMessaging(app);
} catch (e) {
  console.log("Messaging non supportato in questo browser");
}
export { messaging, getToken, onMessage };
export { firebaseConfig };
export default app;
